<template>
  <div class>
    <Toast />

    <div class="card">
      <h5>
        <b>Buat Penerimaan</b>
      </h5>
      <div class="p-grid p-fluid p-mb-3">
        <div class="p-col-12 p-md-6 p-lg-4">
          <label>Nomor Bon</label>
          <div>
            <InputText
              v-model="inputData.doc_number"
              placeholder="Nomor Bon"
              @keyup.prevent="isError.doc_number = false"
            />
          </div>
          <small class="p-error" v-if="isError.doc_number">{{
            error_msg.doc_number
          }}</small>
        </div>
        <div class="p-col-12 p-md-6 p-lg-4">
          <label>Tanggal Bon</label>
          <div>
            <InputText
              type="date"
              v-model="inputData.doc_date"
              @change="isError.doc_date = false"
            />
          </div>
          <small class="p-error" v-if="isError.doc_date">{{
            error_msg.doc_date
          }}</small>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead>
              <th>Kode</th>
              <th>Nama</th>
              <th>Jumlah</th>
              <th>Harga (Rp)</th>
              <th>Total (Rp)</th>
              <th>Hapus</th>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items_temp" :key="k">
                <td>
                  <AutoComplete
                    placeholder="Code"
                    :dropdown="true"
                    :multiple="false"
                    v-model="an_item.selected_item"
                    :suggestions="filteredItems"
                    @complete="getItems"
                    @input="chooseDropdownChanges(k)"
                    field="code"
                  >
                    <template #item="slotProps">
                      <div class="outlet-item">
                        <div class="ml-2">{{ slotProps.item.name }}</div>
                        <div style="font-style: italic; font-size: 12px">
                          {{ slotProps.item.code }}
                        </div>
                      </div>
                    </template>
                  </AutoComplete>
                  <small class="p-error" v-if="isError.items[k].id">{{
                    error_msg.items[k].id
                  }}</small>
                </td>
                <td>
                  <InputText
                    :disabled="true"
                    v-model="an_item.name"
                    placeholder="Nama"
                    @change="nameChanges(k, an_item)"
                  />
                </td>
                <td>
                  <InputText
                    type="number"
                    v-model="an_item.qty"
                    placeholder="0"
                    @keyup.prevent="qtyChanges(k)"
                    @change="qtyChanges(k)"
                  />
                  <small class="p-error" v-if="isError.items[k].qty">{{
                    error_msg.items[k].qty
                  }}</small>
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.price"
                    :disabled="true"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.total"
                    :disabled="true"
                  />
                </td>
                <td scope="row" class="trashIconContainer">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k, an_item)"
                  ></Button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td class="p-text-right">
                  <label>Total Harga (Rp)</label>
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="total_price"
                    :disabled="true"
                  />
                </td>
                <td>
                  <Button
                    icon="pi pi-plus"
                    label="Add"
                    class="p-mr-2"
                    @click="addNewRow()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="p-grid p-justify-center">
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="saveChanges()"
            :disabled="loading.createButton"
          >
            Buat
            <span v-if="loading.createButton">
              <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items_checked: false,
      isError: {
        doc_number: false,
        doc_date: false,
        items: [{ id: false, qty: false }]
      },
      error_msg: {
        doc_number: '',
        doc_date: '',
        items: [{ id: '', qty: '' }]
      },
      items: [],
      total_price: 0,
      items_temp: [
        {
          selected_item: '',
          name: null,
          qty: null,
          price: 0,
          total: 0
        }
      ],
      inputData: {
        doc_number: '',
        doc_date: '',
        items: [
          {
            id: 0,
            qty: 0
          }
        ]
      },
      loading: {
        createButton: false
      },
      filteredItems: null
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems(event) {
      let code = ''
      if (event.query != null) {
        code = event.query
      } else {
        code
      }
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/list/items?code=${code}&show_empty_stock=true&limit=5`
        )
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items

            let query = event.query
            let filteredItems = []
            for (let i = 0; i < this.items.length; i++) {
              let item = this.items[i]
              if (item.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filteredItems.push(item)
              } else if (
                item.code.toLowerCase().indexOf(query.toLowerCase()) === 0
              ) {
                filteredItems.push(item)
              }
            }
            this.filteredItems = filteredItems
          }
        })
    },

    chooseDropdownChanges(index) {
      if (this.items_temp[index].selected_item instanceof Object) {
        this.isError.items[index].id = false

        this.inputData.items[index].id = this.items_temp[index].selected_item.id
        this.items_temp[index].price = parseFloat(
          this.items_temp[index].selected_item.price
        )
        this.items_temp[index].name = this.items_temp[index].selected_item.name

        this.calculateLineTotal(index)
      }
    },

    qtyChanges(index) {
      this.isError.items[index].qty = false
      this.inputData.items[index].qty = parseInt(this.items_temp[index].qty)
      this.calculateLineTotal(index)
    },

    calculateLineTotal(index) {
      let qty = 0
      if (this.items_temp[index].qty) {
        qty = parseInt(this.items_temp[index].qty)
      }

      this.items_temp[index].total = qty * this.items_temp[index].price
      this.calculateTotal()
    },

    calculateTotal() {
      this.total_price = this.items_temp.reduce(function (sum, item) {
        return sum + item.total
      }, 0)
    },

    saveChanges() {
      if (this.inputData.doc_number == '') {
        this.isError.doc_number = true
        this.error_msg.doc_number = 'fill this input first'
      }
      if (this.inputData.doc_date == '') {
        this.isError.doc_date = true
        this.error_msg.doc_date = 'choose date first'
      }

      for (let i = 0; i < this.inputData.items.length; i++) {
        if (
          !this.inputData.items[i].id <= 0 ||
          !this.inputData.items[i].id === '0'
        ) {
          this.items_checked = true
        } else {
          this.isError.items[i].id = true
          this.error_msg.items[i].id = 'select item first'
          this.items_checked = false
          break
        }
        if (
          this.inputData.items[i].qty <= 0 ||
          this.inputData.items[i].qty === '0' ||
          this.inputData.items[i].qty === ''
        ) {
          this.isError.items[i].qty = true
          this.error_msg.items[i].qty = 'qty must > 0'
          this.items_checked = false
          break
        } else {
          this.items_checked = true
        }
      }

      if (
        this.total_price > 0 &&
        this.inputData.doc_number != '' &&
        this.inputData.doc_date != '' &&
        this.items_checked == true &&
        this.inputData.items.length > 0
      ) {
        this.loading.createButton = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds`,
            this.inputData
          )
          .then(response => {
            this.loading.createButton = false
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Submit items Success',
                detail: 'Congrats, those items has been submitted',
                life: 3000
              })
              this.total_price = 0
              this.items_temp = [
                {
                  qty: 0,
                  price: 0,
                  total: 0
                }
              ]
              this.inputData = {
                doc_number: '',
                doc_date: '',
                items: [
                  {
                    id: 0,
                    qty: 0
                  }
                ]
              }
            } else if (response.status === 500) {
              this.$toast.add({
                severity: 'error',
                summary: 'Bon number has not been submitted',
                detail: 'Please, check the Bon number and try again',
                life: 3000
              })
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Submit items Failed',
                detail: "Sorry, those items hasn't submitted",
                life: 3000
              })
            }
          })
      }
    },

    deleteRow(index, an_item) {
      var idx = this.items_temp.indexOf(an_item)
      if (idx > -1) {
        this.items_temp.splice(idx, 1)
        this.inputData.items.splice(idx, 1)
        this.isError.items.splice(idx, 1)
        this.error_msg.items.splice(idx, 1)
      }
      this.calculateTotal()
    },
    addNewRow() {
      this.items_temp.push({
        code: '',
        name: '',
        price: 0,
        qty: null,
        total: 0
      })
      this.inputData.items.push({
        id: 0,
        qty: null
      })
      this.isError.items.push({ id: false, qty: false })
      this.error_msg.items.push({ id: '', qty: '' })
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
